import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { ReactComponent as MicrosoftLogo } from "../../../assets/icons/microsoft-logo.svg";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((e) => {
      console.log(e);
    });
  };
  return (
    <>
      <button
        onClick={handleLogin}
        className="h-10 px-3 flex items-center gap-3 bg-microsoft-gray text-[15px] font-semibold text-white"
      >
        <MicrosoftLogo className="h-[21px] w-[21px]" />
        Sign in with Microsoft
      </button>
    </>
  );
};
